routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.categorySales', {
      url: __env.routes.categorySales,
      template: `<category-products page-name="PAG-43" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categorySlugProducts', {
      url: __env.routes.categorySlugProducts,
      template: `<category-products page-name="PAG-20" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.asideCategorySlug', {
      url: "categories/{categorySlug}",
      template: `<category sh-ctrl="shCtrl"></category>`
    })
    .state('home.productSearch', {
      url: __env.routes.productSearch,
      template: `<category-products page-name="PAG-26" search="true" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categoryIdProducts', {
      url: __env.routes.categoryIdProducts,
      template: `<category-products page-name="PAG-20" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.promotionsProducts', {
      // url: __env.routes.promotionProducts,
      url: __env.routes.promotionsProducts,
      template: `<category-products page-name="PAG-43" sh-ctrl="shCtrl"></category-products>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category-products/category-products.config.js
 **/